<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="delivery_title">
          <Title current-name="Доставка и оплата">
            {{ pageTitle }}
          </Title>
        </div>
      </div>
    </div>
    <div class="row delivery_check">
      <div class="col-12">
        <CheckDelivery />
      </div>
    </div>
    <div class="row delivery_map">
      <div class="col-12 delivery_map_col">
        <div class="delivery_map-info row">
          <div class="col-md-4">
            <MapInfo
              title="Красная зона"
              description="Среднее время доставки: <strong>1ч 30 мин</strong><br> Минимальная сумма заказа: <strong>1 900₽</strong>"
            >
              <img src="/redlight.svg" alt="">
            </MapInfo>
          </div>
          <div class="col-md-4">
            <MapInfo
              title="Желтая зона"
              description="Среднее время доставки: <strong> 60 мин</strong><br> Минимальная сумма заказа: <strong>1 400₽</strong>"
            >
              <img src="/orangelight.svg" alt="">
            </MapInfo>
          </div>
          <div class="col-md-4">
            <MapInfo
              title="Зеленая зона"
              description="Среднее время доставки: <strong> 45  мин</strong><br> Минимальная сумма заказа: <strong>900₽</strong>"
            >
              <img src="/greenlight.svg" alt="">
            </MapInfo>
          </div>
        </div>
      </div>
      <div class="col-12  delivery_map_col">
        <MapZone />
      </div>
    </div>

    <pickup-points-list />

    <div class="row delivery_features">
      <div class="col-12 delivery_features_title">
        <InnerTitle>
          <template v-slot:title>
            Оплачивайте как удобно
          </template>
          <template v-slot:subtitle>
            Вам доступны любые способы оплаты
          </template>
        </InnerTitle>
      </div>
      <div class="col-6 col-md-3">
        <div class="feature_item">
          <Feature title="Оплата <br> наличными курьеру" img="/features/payment/coins.svg" color="#fce6d7" />
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="feature_item">
          <Feature title="Оплата банковской <br> картой курьеру" img="/features/payment/cards.png" color="#fce6d7" />
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="feature_item">
          <Feature title="Онлайн оплата <br> на сайте" img="/features/payment/paycheck.png" color="#fce6d7" />
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="feature_item">
          <Feature title="Оплата по счёту<br> (для юр. лиц)" img="/features/payment/hand.png" color="#fce6d7" />
        </div>
      </div>
    </div>
    <div class="row delivery_alert">
      <div class="col">
        <Alert>
          Ознакомиться с полными условиями оплаты и доставки, а также возврата денежных средств вы можете в
          <nuxt-link to="/legal-info/terms-of-payment-and-delivery" tag="a">
            этом разделе сайта
          </nuxt-link>
        </Alert>
      </div>
    </div>
    <!--    <regions-list />-->
    <div class="row delivery_banner">
      <div class="col">
        <Banner />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import CheckDelivery from '@/components/page/CheckDelivery'
import MapZone from '@/components/page/MapZone'
import MapInfo from '@/components/page/MapInfo'
import InnerTitle from '@/components/UI/InnerTitle'
import Feature from '@/components/UI/Feature'
import Alert from '@/components/UI/Alert'
import Banner from '@/components/page/Banner'
import Ruble from '@/components/UI/Ruble'
import { mapGetters } from 'vuex'
import RegionsList from '~/components/page/RegionsList'
import PickupPointsList from '~/components/page/PickupPointsList'

export default {
  components: { PickupPointsList, RegionsList, Title, CheckDelivery, MapZone, MapInfo, InnerTitle, Feature, Alert, Banner, Ruble },
  computed: {
    ...mapGetters({
      pageTitle: 'seo/getPageTitle',
    }),
  },
  asyncData ({ store }) {
    /** Set default meta tags */
    store.commit('seo/setMetaFieldsDefaults', {
      metaTitle: `Доставка и оплата ${store.getters['region/getCurRegionNamePadeg']} | СУШИСЕТ`,
      metaDescription: ``,
      pageTitle: `Доставка и оплата ${store.getters['region/getCurRegionNamePadeg']}`,
    })
  },
  created () {
    this.$store.commit('changeMenu', this.$route.name)
  },
}
</script>

<style lang="less">
.delivery {
  &_title {
    margin-bottom: 34px;
    margin-top: 20px;
  }

  &_check {
    margin-bottom: 20px;

    @media screen and (max-width: 768px) {
      margin-bottom: 30px;
    }
  }

  &_map {
    margin-bottom: 44px;

    @media screen and (max-width: 992px) {
      &_col {
        &:last-child {
          order: -1;
          margin-bottom: 60px;
        }
      }
    }

    &-info {
      margin-bottom: 20px;
      /*height: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;*/

     /* & > .map_info {
        &:not(:last-child) {
          margin-bottom: 14px;
        }
      }*/
    }
  }

  &_features {
    margin-bottom: 60px;

    &_title {
      margin-bottom: 50px;
    }
  }

  &_alert {
    margin-bottom: 35px;

    @media screen and (max-width: 768px) {
      margin-bottom: 85px;
    }
  }

  &_banner {
    margin-bottom: 26px;
  }
}
</style>
